
export {} from '@clayui/color-picker';
import __x__ from '@clayui/color-picker';export default __x__;